import React, { useState } from "react";
import "./DeliveryAddressPicker.scss"
import close from "../../../assets/close.svg"
import deliveryUC from "../../../assets/delivery-cycle.svg"
import CustomInput from "../../CustomInput/CustomInput";
import info from "../../../assets/info-filled.svg"
import loc from "../../../assets/location-arrow.svg"
import globalValues from "../../../../../../utilities/apiRequests/globalValues";
import AddressAutoComplete from "./AddressAutoComplete";

const DeliveryAddressPicker = ({ isOpen, setIsOpen, setLocation }) => {
    const [value, setValue] = useState("")
    const toggleDrawer = () => setIsOpen(!isOpen);

    const [error, setError] = useState(null);
    const apiKey = globalValues.keys.REACT_APP_LOCATION_GOOGLE_API_KEY;

    const reverseGeocode = async (lat, lng) => {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            console.log(data, "d")
            if (data.status === 'OK') {
                const result = data.results[0];
                const components = result.address_components;

                const getComponent = (type) =>
                    components.find((c) => c.types.includes(type))?.long_name || '';
                const getShortComponent = (type) =>
                    components.find((c) => c.types.includes(type))?.short_name || '';
                setLocation({
                    city: getComponent('locality'),
                    state: getComponent('administrative_area_level_1'),
                    country: getComponent('country'),
                    postal: getComponent('postal_code'),
                    lat: lat,
                    lng: lng,
                    countryCode: getShortComponent('country'),
                    addressLine1: getComponent("street_number") + " " + getComponent("route"),

                });
            } else {
                setError('Could not get address details.');
            }
        } catch (e) {
            setError('Failed to connect to geocoding service.');
        }
    };



    return (
        <div className="DeliveryAddressPicker">
            {isOpen && <div className="drawer-overlay" onClick={toggleDrawer} />}
            <div className={`DeliveryAddressPicker-drawer ${isOpen ? 'open' : ''}`}>
                <div className="drawer-header">
                    <img alt='' src={close} className="close-button" onClick={toggleDrawer} />
                    <img alt='' src={deliveryUC} className="type-icon " />
                    <div className='right-drawer-header'>Delivery Address</div>
                </div>
                <div className="drawer-content-container">
                    <div className="address-cont">
                        <AddressAutoComplete
                            apiKey={apiKey}
                            onPlaceSelected={(place) => {
                                console.log('Selected Place:', place);
                            }} />
                        <div className="address-cont-text">
                            <img alt="" src={info} className="info-icon" />
                            Enter your address to check if you're in our delivery area
                        </div>
                    </div>
                    <div className="current-address-picker"
                        onClick={() => {
                            if (!navigator.geolocation) {
                                setError('Geolocation not supported');
                                return;
                            }

                            navigator.geolocation.getCurrentPosition(
                                (position) => {
                                    const { latitude, longitude } = position.coords;
                                    reverseGeocode(latitude, longitude);
                                },
                                (err) => {
                                    setError('Location access denied or failed.');
                                }
                            );
                        }}>
                        <div className="current-address-picker-header">
                            <img alt="" src={loc} className="loc-icon" />
                            Use Current Location
                        </div>
                        <div className="current-address-picker-sub">
                            Allow location access for faster delivery
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default DeliveryAddressPicker